import type { PublicMarketplaceCategory } from 'modules/test/types';
import { PUBLIC_TEST_CATEGORIES, normalizeCategorySlug } from 'modules/test/public-categories';

export interface CatalogCategory {
  id: string;
  label: string;
}

type Translate = (key: string) => string;

/** The API sends Uzbek, English and Russian labels; pick the one for the active language. */
function localizedLabel(category: PublicMarketplaceCategory, language?: string): string {
  const base = (language ?? 'uz').split('-')[0];
  if (base === 'en') return category.labelEn || category.label;
  if (base === 'ru') return category.labelRu || category.label;
  return category.label;
}

/** The API's categories when it has any, else the built-in list. */
export function catalogCategories(
  dynamic: PublicMarketplaceCategory[] | undefined,
  t: Translate,
  language?: string,
): CatalogCategory[] {
  if (dynamic && dynamic.length > 0) {
    return dynamic.map((category) => ({
      id: category.id,
      label: localizedLabel(category, language),
    }));
  }
  return PUBLIC_TEST_CATEGORIES.map(({ id, labelKey }) => ({ id, label: t(labelKey) }));
}

/** A test stores a category slug or one of its aliases ("umumiy-fanlar"); resolve it to the label. */
export function categoryLabelFor(categories: CatalogCategory[], raw?: string): string | undefined {
  if (!raw) return undefined;
  const slug = normalizeCategorySlug(raw);
  const match = categories.find(
    ({ id }) => id !== 'all' && (id.toLowerCase() === slug || id.toLowerCase() === raw.toLowerCase()),
  );
  return match?.label;
}
